import { render } from "./CustomTable.vue?vue&type=template&id=29ec1414&scoped=true&ts=true"
import script from "./CustomTable.vue?vue&type=script&lang=ts"
export * from "./CustomTable.vue?vue&type=script&lang=ts"

import "./CustomTable.vue?vue&type=style&index=0&id=29ec1414&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29ec1414"]])

export default __exports__